import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import {
  Project,
  ProjectsListPage,
  ProjectsQuery,
} from '../../interfaces/state/entities/project.interface';
import { IProjectsService } from '../../interfaces/services/projects-service.interface';
import { FloorsMockService } from '../floors/floors-mock.service';

@Injectable({ providedIn: 'root' })
export class ProjectsMockService implements IProjectsService {
  private readonly floorsService = inject(FloorsMockService);
  private projects: Project[] = [];
  private idCounter = 0;

  constructor() {
    const now = new Date();
    this.projects = [
      {
        id: '1',
        name: 'Office Building A',
        floorCount: 4,
        dateCreated: new Date(now.getTime() - 60 * 24 * 60 * 60 * 1000),
      },
      {
        id: '2',
        name: 'Retail Complex B',
        floorCount: 3,
        dateCreated: new Date(now.getTime() - 45 * 24 * 60 * 60 * 1000),
      },
      {
        id: '3',
        name: 'Warehouse Facility',
        floorCount: 2,
        dateCreated: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000),
      },
      {
        id: '4',
        name: 'Empty Project',
        floorCount: 0,
        dateCreated: new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000),
      },
    ];
    this.idCounter = this.projects.length;
  }

  getProjects(query: ProjectsQuery = {}): Observable<ProjectsListPage> {
    const direction = query.direction ?? 'Descending';
    const projects = this.projects
      .map((project) => ({
        ...project,
        floorCount: this.floorsService.getFloorCountByProject(project.id),
      }))
      .sort((a, b) => {
        const delta = b.dateCreated.getTime() - a.dateCreated.getTime();
        if (delta !== 0) {
          return direction === 'Ascending' ? -delta : delta;
        }
        return direction === 'Ascending' ? a.id.localeCompare(b.id) : b.id.localeCompare(a.id);
      });

    return of({
      projects,
      continuation: {
        hasMoreData: false,
        totalCount: projects.length,
      },
    }).pipe(delay(100));
  }

  addProject(name: string): Observable<Project> {
    const project: Project = {
      id: String(++this.idCounter),
      name,
      floorCount: 0,
      dateCreated: new Date(),
    };
    this.projects.push(project);
    return of(project).pipe(delay(100));
  }

  deleteProject(id: string): Observable<void> {
    this.projects = this.projects.filter((p) => p.id !== id);
    return of(undefined).pipe(delay(100));
  }
}
